/**
 * Simplify the word by removing the accents and putting the word in lower case
 */
export const lowerCaseAndRemoveAccents = (word: string): string => {
  return word
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};
